export function isPreviewEnv(environment?: string): boolean {
  return environment !== 'production' && environment !== 'prod';
}
